/**
 * Công tắc giao diện sáng/tối. Ba chế độ: theo hệ điều hành (mặc định), ép
 * sáng, ép tối.
 *
 * Hai khái niệm ở đây KHÁC nhau, và lẫn chúng là nguồn gốc lỗi màu trước đây:
 *
 *   chế độ (mode)      'auto' | 'light' | 'dark'  — lựa chọn của người dùng,
 *                      nhớ trong localStorage.
 *   kết quả (resolved) 'light' | 'dark'           — thứ CSS thật sự nhìn thấy,
 *                      đặt ở thuộc tính `data-theme` trên <html>.
 *
 * `styles/tokens.css` chỉ có một khối chủ đề tối duy nhất và không dùng
 * `@media (prefers-color-scheme: dark)`, nên 'auto' phải được quy đổi ở đây
 * chứ không để CSS tự lo. Lần quy đổi đầu tiên do đoạn script inline trong
 * index.html làm, để kịp trước lần vẽ đầu.
 */
const KEY = 'farmer.theme';
const ORDER = ['auto', 'light', 'dark'];
const META = {
  auto: { icon: 'brightness_auto', label: 'Giao diện: theo hệ thống' },
  light: { icon: 'light_mode', label: 'Giao diện: sáng' },
  dark: { icon: 'dark_mode', label: 'Giao diện: tối' },
};

const osDark = window.matchMedia('(prefers-color-scheme: dark)');

export function getTheme() {
  let v = null;
  try {
    v = localStorage.getItem(KEY);
  } catch {
    /* localStorage bị chặn ở chế độ riêng tư — coi như chưa chọn gì. */
  }
  return ORDER.includes(v) ? v : 'auto';
}

/** Quy đổi chế độ thành thứ CSS hiểu được. */
function resolve(mode) {
  if (mode === 'auto') return osDark.matches ? 'dark' : 'light';
  return mode;
}

export function applyTheme(mode = getTheme()) {
  document.documentElement.setAttribute('data-theme', resolve(mode));
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* Không nhớ được thì thôi, giao diện vẫn đúng cho phiên này. */
  }
  return mode;
}

// Người dùng đổi chủ đề ở cấp hệ điều hành trong lúc đang mở ứng dụng. Chỉ đi
// theo khi đang ở chế độ 'auto' — nếu họ đã ép sáng/tối thì giữ nguyên lựa chọn.
osDark.addEventListener('change', () => {
  if (getTheme() === 'auto') applyTheme('auto');
});

/** Gắn nút xoay vòng auto → sáng → tối vào một `<button>` có sẵn. */
export function bindThemeToggle(button) {
  if (!button) return;
  const paint = (mode) => {
    button.innerHTML = `<span class="ms">${META[mode].icon}</span>`;
    button.title = META[mode].label;
    button.setAttribute('aria-label', META[mode].label);
  };
  paint(applyTheme());
  button.addEventListener('click', () => {
    const next = ORDER[(ORDER.indexOf(getTheme()) + 1) % ORDER.length];
    paint(applyTheme(next));
  });
}
